// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriberModels {
    static getAttributeTypeMap() {
        return PrescriberModels.attributeTypeMap;
    }
}
PrescriberModels.discriminator = undefined;
PrescriberModels.additionalProperties = false;
PrescriberModels.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<PrescriberModel>"
    },
];
//# sourceMappingURL=prescriberModels.js.map